import { useAuth } from '../../app/authContext'
import { useDeviceSettings } from '../../feedback/settings'
import styles from './SettingsScreen.module.css'

export function SettingsScreen() {
  const { operator, deviceId, signOut } = useAuth()
  const { settings, setSetting } = useDeviceSettings()

  return (
    <div className={styles.screen}>
      <div className={styles.settingsList}>
        <SettingRow
          label="بازخورد صوتی"
          description="بیپ متمایز برای ثبت، تکراری و خطا"
          enabled={settings.sound}
          onToggle={() => void setSetting('sound', !settings.sound)}
        />
        <SettingRow
          label="لرزش"
          description="الگوی متفاوت برای هر رویداد"
          enabled={settings.haptics}
          onToggle={() => void setSetting('haptics', !settings.haptics)}
        />
        <SettingRow
          label="چراغ دوربین"
          description="برای راهروهای کم‌نور"
          enabled={settings.torch}
          onToggle={() => void setSetting('torch', !settings.torch)}
        />
      </div>

      <div className={styles.device}>
        <div className={styles.deviceRow}>
          <span className={styles.deviceKey}>دستگاه</span>
          <span className={`${styles.deviceValue} mono`}>{deviceId}</span>
        </div>
        <div className={styles.deviceRow}>
          <span className={styles.deviceKey}>اپراتور</span>
          <span className={`${styles.deviceValue} mono`}>{operator?.username ?? '—'}</span>
        </div>
        <div className={styles.deviceRow}>
          <span className={styles.deviceKey}>نسخه</span>
          <span className={`${styles.deviceValue} mono`}>1.0.0 · PWA</span>
        </div>
      </div>

      <button type="button" className={styles.logout} onClick={() => void signOut()}>
        خروج از حساب
      </button>
    </div>
  )
}

interface SettingRowProps {
  label: string
  description: string
  enabled: boolean
  onToggle: () => void
}

function SettingRow({ label, description, enabled, onToggle }: SettingRowProps) {
  return (
    <button
      type="button"
      className={styles.setting}
      role="switch"
      aria-checked={enabled}
      aria-label={label}
      onClick={onToggle}
    >
      <span className={styles.copy}>
        <span className={styles.label}>{label}</span>
        <span className={styles.description}>{description}</span>
      </span>
      <span className={`${styles.status} ${enabled ? styles.on : styles.off}`}>
        {enabled ? 'روشن' : 'خاموش'}
      </span>
    </button>
  )
}
